import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const mandatory2faSetupGuard: CanActivateFn = () => {
  const router = inject(Router)

  const email = sessionStorage.getItem('login_email')
  const tempToken = sessionStorage.getItem('temp_access_token')
  const tempUserData = sessionStorage.getItem('temp_user_data')

  if (!email || !tempToken || !tempUserData) {
    return router.createUrlTree(['/auth/login'])
  }

  try {
    const userData = JSON.parse(tempUserData)

    if (userData.two_factor_enabled) {
      return router.createUrlTree(['/home'])
    }

    return true
  } catch {
    return router.createUrlTree(['/auth/login'])
  }
}
